// Handles click on split-family swatches inside collection cards.
// CLICK: swaps the card's main image to the sibling product's featured image
//        and updates the card's click-through link, WITHOUT navigating itself -
//        navigation only happens when the image/title (now pointing at the
//        selected sibling) is clicked afterwards.
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-split-swatch-card]').forEach(function (swatchWrap) {
        var card = swatchWrap.closest('.product-block');
        if (!card) return;

        var mainImage = card.querySelector('.product-block__image--primary img, .product-block__image--primary picture img');
        var links = card.querySelectorAll('.product-link');
        var priceEl = card.querySelector('.current--price');

        if (!mainImage) return;

        function setActive(item) {
            swatchWrap.querySelectorAll('.product-block-options__item--active').forEach(function (active) {
                if (active.closest('.product-block-options') === item.closest('.product-block-options')) {
                    active.classList.remove('product-block-options__item--active');
                }
            });
            item.classList.add('product-block-options__item--active');
        }

        swatchWrap.querySelectorAll('.product-block-options__item').forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var targetUrl = item.getAttribute('data-split-target-url');
                var targetImage = item.getAttribute('data-split-target-image');
                var targetPrice = item.getAttribute('data-price');

                if (targetPrice && priceEl) {
                    priceEl.textContent = targetPrice;
                }

                if (targetUrl) {
                    links.forEach(function (link) {
                        link.setAttribute('href', targetUrl);
                    });
                }

                if (targetImage) {
                    mainImage.removeAttribute('srcset');
                    mainImage.removeAttribute('data-srcset');
                    mainImage.src = targetImage;
                }

                setActive(item);
            });
        });
    });
});